import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const LongArrowRight = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M18.5425 11.7648L4.05652 11.7648"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.3134 16.4514L20 11.7648L15.3134 7.07812"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
